import React, { Fragment, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faRightFromBracket,
  faUserCircle,
  faCertificate,
  faBarChart,
  faBook,
  faIdBadge,
  faSearch,
  faStore,
  faFire,
} from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Menu, Transition } from '@headlessui/react';
import { logout } from '../../../redux/actions/authentication';
import { getXanoAuthToken } from '../../../redux/actions/authentication';
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';
import { useCookies } from 'react-cookie';
import { setLocation } from '../../../redux/actions/location';
import {
  locationWithPermission,
  locationWithoutPermission,
} from '../../../redux/actions/location';
import { locationCheck } from '../../../utils/locationCheck';
import LoginModal from './LoginModal'
import { IKImage } from 'imagekitio-react';
import { useEffect } from 'react';
import { getEpsScoreData } from '../../../redux/actions/jobEligibilityScore';
import { setEpsData } from '../../../redux/actions/userActivity';
import { CircularProgressbar, buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import { SET_BLACK_OVERLAY, SET_USER_MODAL } from '../../../redux/actions/types';

const NavBarRight = ({ userLoggedIn, setSearchBtn, searchBtn }) => {
  const location = useLocation();
  const email = useSelector((store) => store?.profileDetails?.email);
  const first_name = useSelector((store) => store?.profileDetails?.first_name);
  const user_name = useSelector((store) => store?.profileDetails?.name);
  const [searchParams, setSearchParams] = useSearchParams();
  const profile_image = useSelector(
    (store) => store?.profileDetails?.profile_image
  );
  const user_college = useSelector(
    (store) => store?.profileDetails?.user_college
  );
  const user_coins = useSelector(
    (store) => store?.profileDetails?.user_coins_data?.[0]
  );
  const user_id = useSelector(
    (store) => store?.profileDetails?.id
  );
  const role_type = useSelector((store) => store?.userSubscription?.role_type);
  const subscription_type = useSelector((store) => store?.userSubscription?.subscription_type);
  const isPro = (role_type !== 'basic' && role_type !== undefined);

  const epsData = useSelector(store => store?.userActivity?.eps_score)


  const userLocation = useSelector((store) => store?.location);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies();
  const isEpsCalculated = useSelector((store) => store?.userActivity?.eps_score?.is_eps_calculated) || false;
  const isDarkOverlay = useSelector((store) => store?.appTheme?.blackOverlay);
  const [isLoginModal, setIsLoginModal] = useState(false);
  const regex = /^.*\/.*\/.*\/.*\/\d+$/

  useEffect(() => {
    if (searchParams?.get("isLoginModalOpen") === "true") {
      setIsLoginModal(true);
    }
    if (user_id && !isEpsCalculated && !regex.test(location.pathname)) {
      console.log("run")
      dispatch(getEpsScoreData(user_id, successObj => {
        console.log({ successObj })
        setEpsData(successObj)
      }))
    }
  }, [user_id, isEpsCalculated])

  const getLocation = async (userId) => {
    const result = await locationCheck(userId);
    //console.log(result);
    if (result === true) {
      //console.log('calllleddd')
      dispatch(setLocation(userId));
    } else {
      //console.log('GOOOO' );
      dispatch(locationWithoutPermission(userId));
      const successCallback = async (data) => {
        const latitude = data.coords.latitude;
        const longitude = data.coords.longitude;

        dispatch(locationWithPermission(userId, latitude, longitude));
      };

      setTimeout(() => {
        navigator.geolocation.getCurrentPosition(
          successCallback,
          (error) => { }
        );
      }, 3000);
    }
  };

  function logoutHandler() {
    dispatch(logout());
    removeCookie('authToken', { path: '/' });
    navigate('/courses');
    dispatch({ type: SET_BLACK_OVERLAY, payload: ({ ...isDarkOverlay, is_closed: true, showModal: false }) })
  }

  const profileItems = [
    {
      name: 'My Profile',
      link: '/my-profile/user',
      icon: faUserCircle,
    },
    {
      name: 'My Certificates',
      link: '/my-profile/user/certificates',
      icon: faCertificate,
    },
    {
      name: 'My Personalised Courses',
      link: '/my-profile/user/personalize',
      icon: faFire,
    },
    {
      name: 'My Analytics',
      link: '/my-profile/user/user-analytics',
      icon: faBarChart,
    },
    {
      name: 'My Learnings',
      link: '/my-profile/user/learnings',
      icon: faBook,
    },
    {
      name: 'My Roadmaps',
      link: '/my-profile/user/roadmap',
      icon: faStore,
    },
    {
      name: 'My Referrals',
      link: '/my-profile/user/referrals',
      icon: faIdBadge,
    },
    {
      name: 'Market Place',
      link: '/market-place',
      icon: faStore,
    },
  ];

  async function authResponse(response) {
    if (response.error || (response.status && response.status === 'unknown')) {
      console.log('Auth Failed: ', response.error);
    } else {
      const tokenID = response?.tokenObj?.access_token;

      await dispatch(
        getXanoAuthToken(tokenID, (successObj) => {
          const userId = successObj?.user_coins_data?.[0]?.user_id;

          getLocation(userId);

          Mixpanel.identify(successObj?.email);
          Mixpanel.track(Constants.Mixpanel.LOG_IN, {
            distinct_id: successObj?.email,
          });
          Mixpanel.people.set({
            $first_name: successObj?.first_name,
            $last_name: successObj?.last_name,
          });
          if (successObj.number_verification) {
            navigate(
              location?.state?.from?.pathname
                ? location?.state?.from?.pathname
                : '/courses',
              { replace: true }
            );
          } else {
            // ReactPixel.trackSingle('333999584825866', 'Lead');
            navigate('/verification', { replace: true });
          }
        })
      );
    }
  }

  const handleCoinsClick = (e) => {
    navigate('/pricing?type=coin');
  };

  return (
    <div className="flex items-center gap-[10px]">
      <div
        className="flex md:hidden cursor-pointer items-center justify-center w-[34px] h-[34px] rounded-full bg-[#EDF1F7] hover:bg-[#E2E8F0] transition-colors"
        onClick={() => setSearchBtn(!searchBtn)}
        title="Search"
      >
        <FontAwesomeIcon icon={faSearch} className="text-[#0E1B2E] text-xs" />
      </div>

      {userLoggedIn ? (
        <>
          {/* <div className="flex items-center justify-between gap-1 md:gap-2">
            <div
              className="flex cursor-pointer items-center gap-1.5 py-1 px-2.5 md:px-3 rounded-full border border-[#E3B84C] bg-[#FCF4DC] hover:bg-[#FBEFC8] transition-colors"
              onClick={() => {
                navigate('/pricing?type=annual');
              }}
            >
              <img
                className="h-[16px] w-[16px] md:h-[18px] md:w-[18px]"
                alt="crown icon"
                src="https://assets.learntube.ai/files/skill_page/pro.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660918183860"
              />
              <span className='text-[#8A6510] text-[11px] md:text-[13px] font-bold'>Upgrade</span>
            </div>

            <div
              onClick={handleCoinsClick}
              className="mx-1 flex cursor-pointer items-center gap-1 py-1 px-2 font-semibold text-xs md:text-sm text-[#8A6510] hover:bg-[#FCF4DC]/40 rounded-full transition-colors"
            >
              <object
                type="image/svg+xml"
                data={`https://assets.learntube.ai/files/Optimized_folder/marketplace-icons/coins.svg?updatedAt=1688368699188`}
                className="h-4 w-4 md:h-5 md:w-5 pointer-events-none"
              ></object>
              <span>{user_coins?.['available-coins']}</span>
            </div>

            {user_college && (
              <div className="mx-1 flex items-center justify-between text-supertiny text-gray-500 md:mx-2 md:text-sm">
                {user_college?.coin_quota?.current_coins}
                <object
                  type="image/svg+xml"
                  data={`https://assets.learntube.ai/files/Optimized_folder/marketplace-icons/coins.svg?updatedAt=1688368699188`}
                  className="ml-1 h-3 w-3 grayscale md:h-6 md:w-6"
                ></object>
              </div>
            )}
          </div> */}
        </>
      ) : (
        <>
          {/* <div
            className="flex cursor-pointer items-center justify-between mr-2"
            onClick={() => {
              navigate('/pricing?type=annual');
            }}
          >
            <img
              className="md:h-8 md:w-8"
              alt="crown icon"
              src="https://assets.learntube.ai/files/skill_page/pro.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660918183860"
            />
          </div> */}
          <button
            className="px-4 py-1.5 md:px-5 md:py-2 rounded-full font-semibold text-xs md:text-sm bg-[#0E1B2E] text-white hover:bg-[#1E3352] transition-colors shadow-sm"
            onClick={(event) => setIsLoginModal(!isLoginModal)}
          >
            Login
          </button>
        </>
      )}
      {
        isLoginModal && <LoginModal isModalEnabled={isLoginModal} setIsModalEnabled={setIsLoginModal} />
      }
      {userLoggedIn && window.innerWidth > 768 ?
        (epsData && epsData.calculated_eps_score > 0 && epsData?.is_visible) ?
          <></>
          // <div className='cursor-pointer w-[3.5rem] h-[3.5rem] flex justify-center items-center ' onClick={() => {
          //   Mixpanel.track(Constants.Mixpanel.JES_ENTRY_NAVBAR_ICON, {
          //     distinct_id: email,
          //   });
          //   navigate('/my-profile/user')
          // }}>
          //   <p className='text-supertiny my-0 mr-1 text-teal-500 font-bold'>{epsData?.calculated_eps_score}%</p>
          //   <CircularProgressbarWithChildren
          //     value={parseInt(epsData?.calculated_eps_score)}
          //     strokeWidth={8}
          //     styles={buildStyles({
          //       pathTransitionDuration: 0.5,
          //       // Colors
          //       pathColor: `#F59E0B`,
          //       textColor: 'white',
          //       trailColor: 'white',
          //     })}>
          //     <img
          //       urlEndpoint="https://assets.learntube.ai/files/"
          //       src='https://assets.learntube.ai/files/Profile-section/thumbUp.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1666696717785'
          //       className="w-6 h-6 md:w-8 md:h-8"
          //       transformation={[{
          //         "height": "50",
          //         "width": "50",
          //       }]}
          //     />
          //   </CircularProgressbarWithChildren>
          // </div>
          :
          <></>
        // <div className='relative cursor-pointer' onClick={() => {
        //   Mixpanel.track(Constants.Mixpanel.JES_ENTRY_NAVBAR_ICON, {
        //     distinct_id: email,
        //   });
        //   navigate('/my-profile/user')
        // }}>
        //   <img
        //     urlEndpoint="https://assets.learntube.ai/files/"
        //     src='https://assets.learntube.ai/files/Profile-section/thumbUp.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1666696717785'
        //     className="w-6 h-6 md:w-8 md:h-8"
        //     transformation={[{
        //       "height": "50",
        //       "width": "50",
        //     }]}
        //   />
        //   <p className='w-2 h-2 bg-red-500 rounded-full absolute top-0 -right-1'></p>
        // </div>
        :
        null
      }

      {userLoggedIn && (
        <div className="flex items-center justify-center" onClickCapture={(e) => setSearchBtn(false)}>
          <Menu
            as="div"
            className="relative inline-block items-center text-left"
          >
            <Menu.Button className={`flex items-center gap-3 p-1 lg:p-[4px_12px_4px_4px] rounded-full border transition-all ${isPro
              ? 'bg-[#FCF4DC] border-[#E3B84C] hover:bg-[#FBEFC8]'
              : 'bg-[#EDF1F7] border-[#DDE4ED] hover:bg-[#E2E8F0]'
              }`}>
              <div className="relative shrink-0">
                {profile_image ? (
                  <img
                    src={profile_image}
                    alt="profile image"
                    className="h-8 w-8 rounded-full object-cover shrink-0"
                  />
                ) : (
                  <div className="h-8 w-8 rounded-full bg-[#0D2F5B] text-white flex items-center justify-center shrink-0">
                    <FontAwesomeIcon
                      className="text-base"
                      icon={faUserCircle}
                    />
                  </div>
                )}
                {isPro && (
                  <span className={`lg:hidden absolute ${role_type === "x" ? '-bottom-2 -right-2' : '-bottom-2 -right-4'} flex items-center px-1 py-[1px] rounded-full text-[7px] font-bold tracking-[0.8px] text-[#3A2B05] bg-gradient-to-r from-[#F7E394] to-[#E8B94A] border-2 border-[#FCF4DC]`}>
                    {role_type === "pro" ? "PRO" : role_type === "x" ? "X" : role_type === "max" ? "MAX" : "TRAIL"}
                  </span>
                )}
              </div>
              <div className="hidden lg:flex items-center gap-1.5">
                <span className="text-[14px] font-semibold text-[#0E1B2E] max-w-[120px] truncate">
                  {first_name || user_name?.split(" ")?.[0]}
                </span>
                {isPro && (
                  <span className="inline-flex items-center px-[7px] py-[3px] rounded-full text-[9px] font-bold tracking-[0.8px] text-[#3A2B05] bg-gradient-to-r from-[#F7E394] to-[#E8B94A]">
                    {role_type === "pro" ? "PRO" : role_type === "x" ? "X" : role_type === "max" ? "MAX" : "TRAIL"}
                  </span>
                )}
                <svg className="w-4 h-4 text-[#4A5A70]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m6 9 6 6 6-6" />
                </svg>
              </div>
            </Menu.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 mt-2 w-72 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="z-[99999] flex flex-col items-center justify-between px-1 py-1 shadow-2xl">
                  <div className="flex w-full items-center justify-evenly">
                    <Menu.Item className="my-4 h-12 w-12 rounded-full">
                      {profile_image ? (
                        ({ active }) => <img src={profile_image} alt="profile image" />
                      ) : (
                        <FontAwesomeIcon
                          className="text-slate-600"
                          icon={faUserCircle}
                        />
                      )}
                    </Menu.Item>
                    <Menu.Item className="text-xl font-bold text-cn_green">
                      {({ active }) => <h5>{user_name}</h5>}
                    </Menu.Item>
                  </div>
                  {profileItems.map((item) => (
                    <Menu.Item>
                      {({ active }) => (
                        <button
                          className={`flex w-full py-2 px-4 text-left text-slate-700 hover:bg-slate-100`}
                          onClick={() => {
                            // setSearchBtn(false);
                            navigate(item.link);
                          }}
                        >
                          <FontAwesomeIcon
                            className="mr-4"
                            icon={item.icon}
                            size="lg"
                          />
                          <p className="font-bold">{item.name}</p>
                          {item.name === 'Market Place' && (
                            <h5 className="rounded-full bg-gradient-to-tr from-red-500 to-red-800 px-1 text-supertiny font-bold text-white">
                              NEW
                            </h5>
                          )}
                        </button>
                      )}
                    </Menu.Item>
                  ))}
                  <Menu.Item>
                    <button
                      className={`flex w-full py-2 px-4 text-left text-slate-700 hover:bg-slate-100`}
                      onClick={() => {
                        // setSearchBtn(false);
                        Mixpanel.track(Constants.Mixpanel.JES_ENTRY_MENU_ICON, {
                          distinct_id: email,
                        });
                        navigate("/my-profile/user");
                      }}
                    >
                      <img
                        urlEndpoint="https://assets.learntube.ai/files/"
                        src='https://assets.learntube.ai/files/Profile-section/thumbUp.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1666696717785'
                        className="w-6 h-6 md:w-8 md:h-8 mr-2"
                        transformation={[{
                          "height": "50",
                          "width": "50",
                        }]}
                      />
                      <p className="font-bold">My Job Score</p>
                    </button>

                  </Menu.Item>
                  <hr className="m-0 w-full bg-slate-200" />
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        className={`group my-2 w-full rounded px-2 py-2 text-center font-bold text-slate-400 hover:bg-slate-100`}
                        onClick={logoutHandler}
                      >
                        <FontAwesomeIcon
                          className="mr-1 rotate-180"
                          icon={faRightFromBracket}
                        />
                        Logout
                      </button>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      )}
    </div>
  );
};

export default NavBarRight;
